/**
 * Énumérations unifiées pour les états des campagnes et référents
 * Conformément aux exigences 1.1 et 1.2 pour la cohérence des états
 */

/**
 * États possibles d'une campagne dans son cycle de vie
 * Utilise une terminologie française cohérente
 */
export enum CampaignStatus {
  BROUILLON = 'Brouillon',
  EN_ATTENTE_CANDIDAT = 'En attente candidat',
  EN_ATTENTE_REFERENTS = 'En attente référent(s)',
  TERMINE = 'Terminé',
  ANNULEE = 'Annulée',
  REFUSE = 'Refusé'
}

/**
 * États possibles d'un référent dans le processus d'évaluation
 * Utilise une terminologie française cohérente
 */
export enum ReferentStatus {
  INVITE = 'Invité',
  RELANCE = 'Relancé',
  A_REPONDU = 'A répondu',
  COMPLETE = 'Complété'
}

/**
 * Types d'actions pour l'audit des transitions d'état
 */
export enum AuditAction {
  STATE_TRANSITION = 'state_transition',
  RULE_VIOLATION = 'rule_violation',
  DATA_VALIDATION = 'data_validation',
  PERMISSION_CHECK = 'permission_check'
}

/**
 * Types d'entités pour l'audit
 */
export enum EntityType {
  CAMPAIGN = 'campaign',
  REFERENT = 'referent',
  BUSINESS_RULE = 'business_rule',
  VALIDATION = 'validation'
}